import React from 'react';
import { Col } from 'reactstrap';
import { object, string } from 'prop-types';

const ContractsInput = ({ colProps, children, className }) => {
  return (
    <Col {...colProps} className={className}>
      {children}
    </Col>
  );
};

ContractsInput.propTypes = {
  colProps: object,
  className: string,
};

ContractsInput.defaultProps = {
  colProps: {},
  className: '',
};

export default ContractsInput;
